import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  const objElement = document.querySelector('.technology-obj');
  const technologySec = document.querySelector('.technology-sec');

  if (objElement && technologySec) {
    gsap.set(objElement, { autoAlpha: 0 });  // 初期状態で見えなくする

    ScrollTrigger.create({
      trigger: technologySec,
      start: 'top bottom',  // .technology-sec のトップがビューポートのボトムに入るとき
      end: 'bottom center', // .technology-sec のボトムがビューポートの中央に達したとき
      scrub: true,
      onEnter: () => gsap.to(objElement, { autoAlpha: 1, duration: 0.3 }),  // .technology-sec が可視化されたらアニメーションを開始
      onLeave: () => gsap.to(objElement, { autoAlpha: 0, duration: 0.3 }),  // .technology-sec が可視領域を通り過ぎたらアニメーションを終了
      onEnterBack: () => gsap.to(objElement, { autoAlpha: 1, duration: 0.3 }),  // スクロールバックで同様にアニメーションを再開始
      onLeaveBack: () => gsap.to(objElement, { autoAlpha: 0, duration: 0.3 }),  // スクロールバックでアニメーションを再終了
      //markers: true,
    });
  }
});
